/* eslint-disable no-template-curly-in-string */
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: 'Voce deixou esse campo em branco',
  },
  string: {
    max: 'O campo deve ter no máximo ${max} caracteres',
    min: 'O campo deve ter no mínimo ${min} caracteres',
  }
});

const registerAddressSchema = yup.object().shape({
  address_description: yup.string().max(80).required(),
  postal_code: yup.string().required().matches(/[0-9]{5}-[0-9]{3}/, {message: 'CEP inválido'}),
  district: yup.string().min(2).max(2).required(),
  city: yup.string().max(255).required(),
  neighborhood: yup.string().max(255).required(),
  address: yup.string().max(255).required(),
  address_number: yup.string().max(255).required(),
  address2: yup.string().max(255),
});

export default registerAddressSchema;

/**
 * 
 *  'address_description' => ['required', 'string', 'max:80'],
            'postalcode' => ['required', 'regex:/[0-9]{8}/'],
            'uf' => ['required', 'string', 'max:2', 'min:2'],
            'city' => ['required', 'string', 'max:255'],
            'neighborhood' => ['required', 'string', 'max:255'],
            'address' => ['required', 'string', 'max:255'],
            'number' => ['required', 'string', 'max:255'],
            'address2' => ['string', 'max:255'],
 */
